import * as React from 'react';
import { FormComponentProps } from 'antd/lib/form';
import { PbrInputMoney } from 'src/components/common/PbrInputMoney/PbrInputMoney';

interface IPrecatorioInterestProps extends FormComponentProps {
  customClass?: string;
  interest: number;
  onChange: (value: number) => void;
}

export const PrecatorioInterest: React.FC<IPrecatorioInterestProps> = ({
  interest,
  onChange,
  form
}) => (
    <PbrInputMoney
      placeholder="Juros"
      name="interest"
      value={interest}
      formItemProps={{ label: "Juros" }}
      onChange={e => onChange(e)}
      formWrapper={form}
    />
  );



// WEBPACK FOOTER //
// ./src/components/PricingComponents/PrecatorioInterest/PrecatorioInterest.tsx